<template>
  <div>
    <Card>
      <TablePaginate :columns="columns"
                     :data="rebate_order_records"
                     :loading="loading"
                     :meta="meta"
                     :changePage="changePage"></TablePaginate>
    </Card>
  </div>
</template>

<script>
import i18n from '../../locales/index'

import { mapGetters, mapActions } from 'vuex'
import TablePaginate from '@/components/TablePaginate'
// import { deleteButtonInTable } from '@/libs/table-render'

export default {
  components: {
    TablePaginate
  },
  data () {
    return {
      columns: [
        {
          title: i18n.t('pages_promote_bill_info_869'),
          key: 'id',
          width: 100
        },
        {
          title: i18n.t('pages_promote_bill_info_870'),
          key: 'company_rebate_price'
        },
        {
          title: i18n.t('pages_promote_bill_info_871'),
          key: 'staff_rebate_price'
        },
        {
          title: i18n.t('pages_promote_bill_info_872'),
          key: 'fresh_order_created_at'
        },
        // {
        //   title: '操作',
        //   key: 'action',
        //   width: 200,
        //   align: 'center',
        //   fixed: 'right',
        //   render: (h, params) => {
        //     const children = []
        //     children.push(
        //       deleteButtonInTable(this, h, params)
        //     )
        //     return h('div', children)
        //   }
        // }
      ]
    }
  },
  created () {
    this.changePage(1)
  },
  computed: {
    ...mapGetters('rebate_order_record', ['rebate_order_records', 'meta', 'loading'])
  },
  methods: {
    ...mapActions('rebate_order_record', [
      'clearRecord',
      'index',
      'show',
      'create',
      'update',
      'destroy',
      'get_info'
    ]),
    changePage (page) {
      const { target, id } = this.$route.params
      this.get_info({
        page,
        [target === 'company' ? 'company_rebate_record_id' : 'staff_rebate_record_id']: id
      })
    }
  }
}
</script>
